export default __webpack_public_path__ + "static/media/html-5.b1adfd9e.svg";